export default function () {
  const route = useRoute()
  const pageType = computed(() => (typeof route.meta.pageType === 'string' ? route.meta.pageType : ''))
  const localeStore = useLocaleStore()
  const siteLanguage = localeStore.selectedLanguage

  const base = computed(() => ({
    event: 'fsf_events',
    site_language: siteLanguage,
    page_type: pageType.value
  }))

  function pushFSFDataLayer(data: object) {
    pushToDataLayer({
      ...base.value,
      ...data
    })
  }

  function pushFSFCalendarSearchDataLayer(data: object) {
    pushToDataLayer({
      generic_event_name: 'fsf_submit',
      event_category: 'fsf_calendar',
      ...base.value,
      ...data
    })
  }

  function pushFsfFlightHotelFormSubmitDataLayer(data: object) {
    pushToDataLayer({
      generic_event_name: 'fsf_hotel_flight',
      event_category: 'airbaltic_holidays',
      ...base.value,
      ...data
    })
  }

  function pushFsfRecentSearchClickedDataLayer(data: object) {
    pushToDataLayer({
      generic_event_name: 'fsf_submit',
      event_category: 'recent_search',
      ...base.value,
      ...data
    })
  }

  function pushFsfTopLabelsDataLayer(data: object) {
    pushToDataLayer({
      generic_event_name: 'fsf_top_labels',
      ...base.value,
      ...data
    })
  }

  return {
    pushFSFDataLayer,
    pushFSFCalendarSearchDataLayer,
    pushFsfFlightHotelFormSubmitDataLayer,
    pushFsfRecentSearchClickedDataLayer,
    pushFsfTopLabelsDataLayer
  }
}
